import wizTreeSelect from './index.vue'

wizTreeSelect.install = (Vue) => {
  Vue.component(wizTreeSelect.name, wizTreeSelect)
}

export default wizTreeSelect
